export const translations = {
    en: {
        nav: {
            product: 'Product',
            ingredients: 'Ingredients',
            science: 'Science',
            business: 'Business',
            blog: 'Blog',
            about: 'About',
            account: 'Account',
            preorder: 'Pre-order - €35',
            login: 'Login',
            dashboard: 'Dashboard',
            logout: 'Log out',
            faq: 'FAQ',
        },
        banner: {
            /* Legacy keys retained (used elsewhere across pages) */
            presale: 'PRE-SALE ACTIVE',
            ships: 'Ships',
            ships_value: 'Expected November/December 2026',
            /* New calm-banner keys */
            preorder_label: 'Pre-order',
            ships_line: 'Ships November/December 2026',
            shipping_line: 'Free shipping in NL',
        },
        hero: {
            /* Legacy keys retained for compatibility */
            badge: 'PRE-ORDER NOW',
            h1_line1: 'For the nights',
            h1_line2: 'your mind won\'t quiet.',
            title_new_line1: 'No vague sleep claims.',
            title_new_line1_a: 'No vague',
            title_new_line1_b: 'sleep claims.',
            title_new_line2: 'Just a formula you can check.',
            title_new_line2_a: 'Just a formula',
            title_new_line2_b: 'you can check.',
            subtext_new: 'A drinkable evening supplement, built on published research. Melatonin-free.',
            explore_cta: 'Explore the formula',
            h2: 'A powder with Glycine (3000mg), Magnesium bisglycinate (200mg elemental Mg), L-Theanine (200mg), Lemon Balm (200mg) and chicory inulin (400mg). Natural cherry flavour, citric acid and a touch of beetroot extract for natural colouring. One scoop in 150ml of water, 30–60 minutes before bed.',
            cta: 'Pre-order - €35',
            cta_short: 'Pre-order - €35',
            was_price: 'Regular price €45 · one-time payment',
            trust1: 'Expected November/December 2026',
            trust2: 'Free NL shipping',
            trust3: 'Full refund any time before we ship',
            trust_row: ['3000mg glycine', 'no melatonin', 'no proprietary blends', 'made in EU'],
            /* Refined ingredient module, replaces the SaaS-style checkmark pills */
            ingredient_label: 'What\'s in each scoop',
            ingredient_module: [
                { dose: '3000 mg', name: 'Glycine' },
                { dose: '200 mg',  name: 'L-Theanine' },
                { dose: '200 mg',  name: 'Magnesium bisglycinate' },
                { dose: '200 mg',  name: 'Lemon Balm' },
            ],
            /* Warm, in-voice funnel copy, no longer reads as a legal disclaimer */
            presale_note: 'You\'re charged today. We ship in November/December 2026, only after every batch clears independent lab testing, and you can request a full refund any time before it goes out.',
            quality_note: 'We only ship once Sleepstack has passed every quality check.',
        },
        howItWorks: {
            title: 'How To Use',
            subtitle: 'Three simple steps, part of your nightly routine.',
            step1_title: 'Mix & Drink',
            step1_desc: 'Dissolve one scoop (7.5g) in 150ml of water, 30–60 minutes before bed.',
            step2_title: 'Same Time, Every Night',
            step2_desc: 'Take it at roughly the same time each night, as part of a consistent wind-down routine.',
            step3_title: 'Stay Consistent',
            step3_desc: 'Use nightly. For ingredient-level information, see our ingredients page.',
        },
        ingredients: {
            title: 'What\'s Inside',
            subtitle: 'Every ingredient at a clinically researched dose.',
            disclaimer: 'The information below is provided for educational purposes only and does not constitute a health claim under EU Regulation No 1924/2006 (NVWA/EFSA). Studies cited were independent and not funded by Sleepstack. This is not medical advice.',
            disclaimer_nl: 'De onderstaande informatie is uitsluitend voor educatieve doeleinden en vormt geen gezondheidsclaim conform EU-verordening nr. 1924/2006 (NVWA/EFSA). Genoemde studies waren onafhankelijk en niet gefinancierd door Sleepstack.',
        },
        science: {
            title: 'Backed by Research',
            subtitle: 'Every ingredient in Sleepstack is supported by peer-reviewed human studies.',
            quote1: '"Glycine supplementation before sleep improved self-reported sleep quality and reduced daytime sleepiness in healthy volunteers."',
            cite1: 'Bannai et al., Frontiers in Neurology (2012)',
            quote2: '"Chronic supplementation with L-theanine was associated with reductions in self-reported stress and improvements in sleep quality in adults."',
            cite2: 'Hidese et al., Nutrients (2019)',
            quote3: '"Magnesium supplementation improved objective and subjective measures of sleep in elderly insomniacs."',
            cite3: 'Abbasi et al., Journal of Research in Medical Sciences (2012)',
        },
        trust: {
            title: 'Why Trust Sleepstack',
            item1_title: 'Full Refund Before Shipping',
            item1_desc: 'Request a full refund any time before your pre-order ships (expected November/December 2026). No questions asked.',
            item2_title: 'GMP-Certified Facility',
            item2_desc: 'Manufactured in an EU GMP-certified facility. Every batch is third-party tested for purity and potency.',
            item3_title: 'Full Transparency',
            item3_desc: 'No proprietary blends. Every ingredient and every dose is printed on the label, and we even publish where each euro of the price goes.',
            item4_title: 'NVWA Compliant',
            item4_desc: 'All claims on this product page are reviewed against EU Regulation No 1924/2006 and NVWA guidelines for dietary supplements.',
        },
        pricing: {
            title: 'Pre-Order Now',
            badge: 'PRE-SALE PRICE',
            price: '€35',
            original: '€45',
            period: 'one-time',
            features: [
                '30 servings (1-month supply)',
                'Natural cherry flavour',
                'Free shipping within NL',
                'Full refund before shipping',
                'Expected November/December 2026, only after passing every quality check',
            ],
            cta: 'Pre-order for €35',
            note: 'Your card is charged €35 now. Subscription available at launch.',
        },
        blog: {
            title: 'The Sleepstack Journal',
            subtitle: 'Articles on sleep, evening routines, stress, caffeine, light and supplements, with the same approach as Sleepstack itself: clear, critical and without unnecessary hype.',
            readMore: 'Read article',
            viewAll: 'View all articles',
            by: 'By',
            minRead: 'min read',
            filter_label: 'Browse by topic',
            filter_all: 'All topics',
            related: 'Related articles',
        },
        faq: {
            title: 'Frequently Asked Questions',
            items: [
                {
                    q: 'Is this a sleeping pill?',
                    a: 'No. Sleepstack is a food supplement in powder form that you mix with water as part of your evening routine. It isn\'t a medicine, and it isn\'t a treatment for insomnia.'
                },
                {
                    q: 'Why a powder?',
                    a: 'Because our formula won\'t fit in a capsule. We\'d have to cut the doses, and that would defeat the point.'
                },
                {
                    q: 'Does it contain melatonin?',
                    a: 'No. Leaving out melatonin was a deliberate choice.'
                },
                {
                    q: 'What\'s in one serving?',
                    a: 'One 7.5 g scoop contains 3,000 mg glycine, 200 mg elemental magnesium (from magnesium bisglycinate), 200 mg L-theanine and 200 mg lemon balm leaf extract, each listed separately on the label. Chicory inulin (400 mg) acts as a carrier, with natural cherry flavour for taste, citric acid for freshness and beetroot extract for colour. No sucralose.'
                },
                {
                    q: 'How do I take Sleepstack?',
                    a: 'Stir one 7.5 g scoop into 150–200 ml of water. Each pouch holds 30 servings. Follow the directions on the label and don\'t exceed the recommended daily dose.'
                },
                {
                    q: 'Does it contain sucralose or artificial sweeteners?',
                    a: 'No. There\'s no sucralose and no artificial sweetener in Sleepstack. Supporting ingredients only go in when they have a clear job: natural cherry flavour for taste, beetroot extract for colour, citric acid for freshness and chicory inulin as a carrier.'
                },
                {
                    q: 'Why these dosages?',
                    a: 'Because the amount matters. For glycine, for example, we use 3 grams, the same amount used in multiple studies. For other ingredients, we also look at the form and composition. On our science page we explain the choices behind every ingredient.'
                },
                {
                    q: 'Is it suitable for daily use?',
                    a: 'The ingredients have strong safety profiles at these doses and are commonly used daily. As with any supplement, we recommend taking a break every few months. Not suitable for pregnant or breastfeeding women, or for anyone under 18.'
                },
                {
                    q: 'Is it safe to combine with medication?',
                    a: 'Taking medication? Show the ingredient list to your doctor or pharmacist before using Sleepstack. They can assess whether the combination is right for you.'
                },
                {
                    q: 'When will pre-orders ship?',
                    a: 'We expect to ship in November/December 2026, once the finished product has passed quality checks. You pay at checkout. If there\'s a delay, we\'ll email you. You can cancel for free any time before shipping.'
                },
                {
                    q: 'Can I cancel or get a refund?',
                    a: 'Yes. Email info@sleepstack.nl before shipping. We\'ll cancel your pre-order and refund you in full.'
                },
                {
                    q: 'What payment methods do you accept?',
                    a: 'Credit/debit card (Visa, Mastercard), iDEAL, Apple Pay and Google Pay.'
                },
                {
                    q: 'Is it vegan and allergen-free?',
                    a: 'Yes. 100% vegan. No gluten, dairy, soy or nuts. Manufactured in a GMP-certified EU facility.'
                },
            ]
        },
        about: {
            title: 'About Sleepstack',
            mission_title: 'Our Mission',
            mission: 'Sleepstack was created for people who value evidence over marketing, professionals who want to sleep better and are tired of supplements that make vague promises backed by nothing. We believe in full ingredient transparency, clinically relevant doses, and honest communication.',
            formula_title: 'The Formula Principles',
            formula: 'Every ingredient in Sleepstack was selected based on four criteria: documented effect in human RCTs, dose matching the research, full transparency (no proprietary blends), and GMP-certified EU manufacturing.',
            team_title: 'Our Researchers',
            contact_title: 'Contact',
        },
        checkout: {
            title: 'Checkout',
            step_cart: 'Cart',
            step_details: 'Details',
            step_shipping: 'Shipping',
            step_payment: 'Payment',
            step_confirmation: 'Confirmation',
            product_name: 'Sleepstack Sleep Powder',
            product_desc: 'Pre-order · 30 servings · natural cherry flavour · expected November/December 2026',
            qty: 'Qty',
            qty_label: 'Quantity',
            qty_max_note: 'Max 5 per order',
            volume_hint: '{{qty}} {{pouch_word}} = ~{{qty}} {{month_word}} of evening use',
            regular_price_short: 'Regular',
            subtotal: 'Subtotal',
            shipping: 'Shipping',
            free: 'Free',
            total: 'Total',
            proceed_details: 'Proceed to details',
            first_name: 'First name',
            last_name: 'Last name',
            email: 'Email address',
            proceed_shipping: 'Proceed to shipping',
            street: 'Street address',
            house_number: 'House number',
            postal_code: 'Postal code',
            city: 'City',
            country: 'Country',
            proceed_payment: 'Proceed to payment',
            order_summary: 'Order Summary',
            complete_order: 'Complete pre-order, €{{amount}}',
            charge_note: 'Your card will be charged €{{amount}} now. Your product is expected to ship in November/December 2026, only once it has passed every quality check.',
            refund_note: 'Full refund available at any time before shipping.',
            trust_points: ['One-time payment', 'No subscription required', 'Ships after quality approval', 'Refund possible before shipping', 'No sucralose', 'No proprietary blends'],
            referral_label: 'Referral code',
            referral_optional: 'optional',
            referral_check: 'Check',
            referral_valid: 'Code valid, your friend will earn a free product once your order has shipped.',
            referral_invalid: 'This code is not recognised.',
            referral_note: 'Using a code does not change your price. The person who gave you the code earns a free product, credited to them 14 days after your order ships, to prevent refund loopholes.',
            discount_label: 'Discount code',
            discount_optional: 'optional',
            discount_apply: 'Apply',
            discount_valid: 'Code applied: −€{{amount}} off your order.',
            discount_invalid: 'This code is invalid or has already been used.',
            back: 'Back',
        },
        login: {
            title: 'Login to Sleepstack',
            subtitle: 'Enter your email and we\'ll send you a magic link. No password needed.',
            email_placeholder: 'your@email.com',
            submit: 'Send login link',
            sending: 'Sending...',
            sent_title: 'Check your email',
            sent_desc: 'We\'ve sent a login link to',
            demo_note: 'Email service not configured. Click to login:',
            demo_btn: 'Click to login (demo)',
            back_home: 'Back to home',
        },
        dashboard: {
            title: 'My Account',
            welcome: 'Welcome back',
            presale_notice: 'You\'re in the pre-sale phase. Subscription management and delivery tracking will be activated after the product launch (expected November/December 2026). The referral programme is live now.',
            orders_title: 'Your Orders',
            no_orders: 'No orders yet.',
            order_id: 'Order',
            order_date: 'Date',
            order_status: 'Status',
            order_amount: 'Amount',
            profile_title: 'Profile',
            name_label: 'Name',
            email_label: 'Email',
            email_lang_label: 'Email language',
            email_lang_hint: "We'll send all your emails (order confirmation, shipping updates, referral credits) in this language.",
            address_label: 'Saved shipping address',
            address_hint: 'Fill this in once, we\'ll autofill it at checkout next time you order.',
            save: 'Save changes',
            saved: 'Saved!',
            logout: 'Log out',
            phase_label: 'Phase',
            phase_value: 'Pre-Sale',
            referral_title: 'Referrals',
            referral_heading: 'Your referral code',
            referral_subhead: 'Share this code. When a friend uses it at checkout, you earn one free month inside your (future) subscription, credited to your account 14 days after their order ships.',
            referral_copy: 'Copy',
            referral_copied: 'Copied!',
            referral_share: 'Share',
            referral_stats_pending: 'Pending',
            referral_stats_available: 'Available credits',
            referral_stats_total: 'Successful referrals',
            referral_redeem: 'Redeem one credit',
            referral_redeem_note: 'Redeemed credits are queued. Once you start a subscription (after launch, expected November/December 2026), each credit covers one month of your ongoing plan, apply them whenever you want.',
            referral_policy_title: 'How it works',
            referral_policy_1: 'Each successful referral gives you one free month inside your subscription. You decide when to apply it, it will replace one monthly billing cycle.',
            referral_policy_2: 'Credits are only added 14 days after your friend\'s order has shipped. This protects us (and every customer) against refund loopholes.',
            referral_policy_3: 'Orders with duplicate payment details or delivery addresses may be flagged and not credited.',
            referral_empty: 'No referrals yet. Share your code to earn your first free month.',
        },
        footer: {
            brandline: 'Build your evening.',
            tagline: 'Evidence first. Designed in the Netherlands, manufactured in the EU.',
            product: 'Product',
            company: 'Company',
            legal: 'Legal',
            links_product: ['Pre-order', 'Ingredients', 'Science', 'FAQ'],
            links_company: ['About', 'Blog', 'Contact'],
            links_legal: ['Privacy Policy', 'Terms & Conditions'],
            disclaimer: 'Dietary supplements are not intended to diagnose, treat, cure, or prevent any disease. Consult a healthcare professional before use. Not suitable for pregnant or breastfeeding women.',
            rights: '© 2026 Sleepstack. All rights reserved.',
        },
        cookie: {
            title: 'We use cookies',
            desc: 'We use necessary cookies for the website to function, and optional analytics cookies to understand how visitors use our site. No tracking without your consent.',
            accept: 'Accept all',
            reject: 'Reject all',
            manage: 'Manage preferences',
            necessary: 'Necessary',
            analytics: 'Analytics',
            marketing: 'Marketing',
            save: 'Save preferences',
            always_on: 'Always on',
        },
        privacy: {
            title: 'Privacy Policy',
        },
        terms: {
            title: 'Terms & Conditions',
        }
    },
    nl: {
        nav: {
            product: 'Product',
            ingredients: 'Ingrediënten',
            science: 'Wetenschap',
            business: 'Business',
            blog: 'Blog',
            about: 'Over',
            account: 'Account',
            preorder: 'Pre-order - €35',
            login: 'Login',
            dashboard: 'Dashboard',
            logout: 'Uitloggen',
            faq: 'FAQ',
        },
        banner: {
            /* Legacy keys retained (used elsewhere across pages) */
            presale: 'VOORVERKOOP ACTIEF',
            ships: 'Verzending',
            ships_value: 'Verwacht november/december 2026',
            /* New calm-banner keys */
            preorder_label: 'Pre-order',
            ships_line: 'Verzending november/december 2026',
            shipping_line: 'Gratis verzending in NL',
        },
        hero: {
            /* Legacy keys retained for compatibility */
            badge: 'PRE-ORDER NOW',
            h1_line1: 'Voor de nachten',
            h1_line2: 'dat je hoofd niet stopt.',
            title_new_line1: 'Geen vage slaapclaims.',
            title_new_line1_a: 'Geen vage',
            title_new_line1_b: 'slaapclaims.',
            title_new_line2: 'Weet wat je neemt en waarom.',
            title_new_line2_a: 'Weet wat je neemt',
            title_new_line2_b: 'en waarom.',
            subtext_new: 'Een drinkbaar avondsupplement, ontwikkeld met gepubliceerd onderzoek als uitgangspunt. Zonder melatonine.',
            explore_cta: 'Bekijk de formule',
            h2: 'Een poeder met Glycine (3000mg), Magnesiumbisglycinaat (200mg elementair Mg), L-Theanine (200mg), Citroenmelisse-extract (200mg) en cichorei-inuline (400mg). Natuurlijke kersensmaak, citroenzuur en een vleugje bietenextract voor natuurlijke kleuring. Eén schep in 150ml water, 30–60 minuten voor het slapengaan.',
            cta: 'Pre-order - €35',
            cta_short: 'Pre-order - €35',
            was_price: 'Reguliere prijs €45 · eenmalige betaling',
            trust1: 'Verwacht november/december 2026',
            trust2: 'Gratis verzending in NL',
            trust3: 'Volledige terugbetaling vóór verzending',
            trust_row: ['3000mg glycine', 'geen melatonine', 'geen proprietary blends', 'geproduceerd in de EU'],
            /* Refined ingredient module, vervangt de SaaS-achtige vinkjes-pillen */
            ingredient_label: 'Wat zit er in één schep',
            ingredient_module: [
                { dose: '3000 mg', name: 'Glycine' },
                { dose: '200 mg',  name: 'L-Theanine' },
                { dose: '200 mg',  name: 'Magnesiumbisglycinaat' },
                { dose: '200 mg',  name: 'Citroenmelisse' },
            ],
            /* Warme, natuurlijke tekst, geen juridische disclaimer meer */
            presale_note: 'Je wordt vandaag afgeschreven. We verzenden in november/december 2026, pas nadat elke batch onafhankelijk in het lab is getest, en je kunt tot aan verzending een volledige terugbetaling aanvragen.',
            quality_note: 'We versturen pas zodra Sleepstack alle kwaliteitscontroles heeft doorstaan.',
        },
        howItWorks: {
            title: 'Gebruiksaanwijzing',
            subtitle: 'Drie eenvoudige stappen, onderdeel van je avondritueel.',
            step1_title: 'Meng & Drink',
            step1_desc: 'Los één schep (7,5g) op in 150ml water, 30–60 minuten voor het slapengaan.',
            step2_title: 'Elke Avond Hetzelfde Moment',
            step2_desc: 'Neem het elke avond ongeveer op hetzelfde tijdstip, als onderdeel van een vast avondritueel.',
            step3_title: 'Blijf Consistent',
            step3_desc: 'Neem het elke avond. Meer weten per ingrediënt? Bekijk onze ingrediëntenpagina.',
        },
        ingredients: {
            title: 'Wat Zit Erin',
            subtitle: 'Elk ingrediënt op een klinisch onderzochte dosis.',
            disclaimer: 'De onderstaande informatie is uitsluitend voor educatieve doeleinden en vormt geen gezondheidsclaim conform EU-verordening nr. 1924/2006 (NVWA/EFSA). Genoemde studies waren onafhankelijk en niet gefinancierd door Sleepstack. Dit is geen medisch advies.',
        },
        science: {
            title: 'Wetenschappelijk Onderbouwd',
            subtitle: 'Elk ingrediënt in Sleepstack is onderbouwd door peer-reviewed studies bij mensen.',
            quote1: '"Glycinesuppletie voor het slapen verbeterde zelfgerapporteerde slaapkwaliteit en verminderde slaperigheid overdag bij gezonde vrijwilligers."',
            cite1: 'Bannai et al., Frontiers in Neurology (2012)',
            quote2: '"Chronische suppletie met L-theanine was geassocieerd met verlaging van zelfgerapporteerde stress en verbetering van slaapkwaliteit bij volwassenen."',
            cite2: 'Hidese et al., Nutrients (2019)',
            quote3: '"Magnesiumsuppletie verbeterde objectieve en subjectieve slaapmaatregelen bij oudere slapers."',
            cite3: 'Abbasi et al., Journal of Research in Medical Sciences (2012)',
        },
        trust: {
            title: 'Waarom Sleepstack Vertrouwen',
            item1_title: 'Volledige Terugbetaling Vóór Verzending',
            item1_desc: 'Annuleer op elk moment vóór de verzending (verwacht november/december 2026) en je krijgt je geld volledig terug. Geen vragen.',
            item2_title: 'GMP-Gecertificeerde Fabriek',
            item2_desc: 'Geproduceerd in een EU GMP-gecertificeerde fabriek. Elke batch wordt door derden getest op zuiverheid en potentie.',
            item3_title: 'Volledige Transparantie',
            item3_desc: 'Geen proprietary blends. Elk ingrediënt en elke dosering staat op het etiket, en we publiceren zelfs waar elke euro van de prijs naartoe gaat.',
            item4_title: 'NVWA Compliant',
            item4_desc: 'Alle claims op deze productpagina zijn getoetst aan EU-verordening nr. 1924/2006 en NVWA-richtlijnen voor voedingssupplementen.',
        },
        pricing: {
            title: 'Pre-order Nu',
            badge: 'PRE-ORDER PRICE',
            price: '€35',
            original: '€45',
            period: 'eenmalig',
            features: [
                '30 doseringen (1 maand voorraad)',
                'Natuurlijke kersensmaak',
                'Gratis verzending binnen NL',
                'Volledige terugbetaling tot aan verzending',
                'Verwacht november/december 2026, pas na alle kwaliteitscontroles',
            ],
            cta: 'Pre-order voor €35',
            note: 'Je kaart wordt nu afgeschreven voor €35. Abonnement beschikbaar bij lancering.',
        },
        blog: {
            title: 'The Sleepstack Journal',
            subtitle: 'Artikelen over slaap, avondroutine, stress, cafeïne, licht en supplementen, met dezelfde insteek als Sleepstack zelf: duidelijk, kritisch en zonder onnodige hype.',
            readMore: 'Artikel lezen',
            viewAll: 'Alle artikelen bekijken',
            by: 'Door',
            minRead: 'min lezen',
            filter_label: 'Bladeren op onderwerp',
            filter_all: 'Alle onderwerpen',
            related: 'Gerelateerde artikelen',
        },
        faq: {
            title: 'Veelgestelde Vragen',
            items: [
                {
                    q: 'Is dit een slaappil?',
                    a: 'Nee. Sleepstack is een voedingssupplement in poedervorm. Je mengt het met water, als onderdeel van je avondroutine. Het is geen geneesmiddel of behandeling voor slapeloosheid.'
                },
                {
                    q: 'Waarom gebruiken jullie poeder?',
                    a: 'Omdat onze formule niet in een pil past. Je zou dan onderdoseren en daarmee afdoen aan de werking.'
                },
                {
                    q: 'Zit er melatonine in?',
                    a: 'Nee. We kiezen bewust voor een formule zonder melatonine.'
                },
                {
                    q: 'Wat zit er in één dosering?',
                    a: 'Eén scoop van 7,5 gram bevat 3.000 mg glycine, 200 mg elementair magnesium uit magnesiumbisglycinaat, 200 mg L-theanine en 200 mg citroenmelisseblad-extract. Deze hoeveelheden staan afzonderlijk op het etiket. Daarnaast gebruiken we 400 mg cichorei-inuline als drager, kersenaroma voor smaak, citroenzuur voor frisheid en bietenrood-extract voor kleur. Zonder sucralose.'
                },
                {
                    q: 'Hoe gebruik ik Sleepstack?',
                    a: 'Meng één scoop van 7,5 gram met 150–200 ml water. Eén zakje bevat 30 doseringen. Volg de gebruiksaanwijzing op het etiket en overschrijd de aanbevolen dagelijkse hoeveelheid niet.'
                },
                {
                    q: 'Zit er sucralose of een kunstmatige zoetstof in?',
                    a: 'Nee. Sleepstack bevat geen sucralose en geen kunstmatige zoetstoffen. Hulpstoffen gebruiken we alleen als ze een duidelijke functie hebben: natuurlijk kersenaroma voor de smaak, bietenrood-extract voor kleur, citroenzuur voor frisheid en cichorei-inuline als drager.'
                },
                {
                    q: 'Waarom deze doseringen?',
                    a: 'Omdat de hoeveelheid ertoe doet. Voor glycine gebruiken we bijvoorbeeld 3 gram: dezelfde hoeveelheid als in meerdere studies. Bij andere ingrediënten kijken we ook naar de vorm en samenstelling. Op onze wetenschapspagina leggen we de keuzes per ingrediënt uit.'
                },
                {
                    q: 'Is het geschikt voor dagelijks gebruik?',
                    a: 'De ingrediënten hebben op deze doseringen een sterk veiligheidsprofiel en worden vaak dagelijks gebruikt. Zoals bij elk supplement raden we een pauze aan om de paar maanden. Niet geschikt voor zwangere of borstvoedende vrouwen of voor kinderen onder de 18.'
                },
                {
                    q: 'Is het veilig te combineren met medicatie?',
                    a: 'Gebruik je medicijnen? Laat de ingrediëntenlijst aan je arts of apotheker zien voordat je Sleepstack gebruikt. Die kan beoordelen of de combinatie geschikt is voor jou.'
                },
                {
                    q: 'Wanneer worden voorbestellingen verzonden?',
                    a: 'We verwachten in november/december 2026 te verzenden, nadat het eindproduct de kwaliteitscontroles heeft doorstaan. Je betaalt bij het bestellen. Bij vertraging mailen we je. Tot aan verzending kun je kosteloos annuleren.'
                },
                {
                    q: 'Kan ik annuleren of geld terugkrijgen?',
                    a: 'Ja. Mail vóór verzending naar info@sleepstack.nl. Dan annuleren we je pre-order en krijg je het volledige bedrag terug.'
                },
                {
                    q: 'Welke betaalmethoden accepteren jullie?',
                    a: 'Credit/debetkaart (Visa, Mastercard), iDEAL, Apple Pay en Google Pay.'
                },
                {
                    q: 'Is het veganistisch en allergenenvrij?',
                    a: 'Ja. 100% veganistisch. Geen gluten, zuivel, soja of noten. Geproduceerd in een GMP-gecertificeerde EU-fabriek.'
                },
            ]
        },
        about: {
            title: 'Over Sleepstack',
            mission_title: 'Onze Missie',
            mission: 'Sleepstack is gemaakt voor mensen die bewijs boven marketing stellen, professionals die beter willen slapen en het moe zijn van supplementen die vage beloften maken zonder onderbouwing. We geloven in volledige transparantie over ingrediënten, klinisch relevante doses en eerlijke communicatie.',
            formula_title: 'De Formuleprincipes',
            formula: 'Elk ingrediënt in Sleepstack is geselecteerd op basis van vier criteria: gedocumenteerd effect in menselijke RCTs, dosering die overeenkomt met het onderzoek, volledige transparantie en GMP-gecertificeerde EU-productie.',
            team_title: 'Onze Onderzoekers',
            contact_title: 'Contact',
        },
        checkout: {
            title: 'Afrekenen',
            step_cart: 'Winkelwagen',
            step_details: 'Gegevens',
            step_shipping: 'Verzending',
            step_payment: 'Betaling',
            step_confirmation: 'Bevestiging',
            product_name: 'Sleepstack Slaappoeder',
            product_desc: 'Pre-order · 30 doseringen · kersensmaak · verwacht november/december 2026',
            qty: 'Aantal',
            qty_label: 'Aantal',
            qty_max_note: 'Max 5 per bestelling',
            volume_hint: '{{qty}} {{pouch_word}} = ~{{qty}} {{month_word}} avondgebruik',
            regular_price_short: 'Normaal',
            subtotal: 'Subtotaal',
            shipping: 'Verzending',
            free: 'Gratis',
            total: 'Totaal',
            proceed_details: 'Doorgaan naar gegevens',
            first_name: 'Voornaam',
            last_name: 'Achternaam',
            email: 'E-mailadres',
            proceed_shipping: 'Doorgaan naar verzending',
            street: 'Straatnaam',
            house_number: 'Huisnummer',
            postal_code: 'Postcode',
            city: 'Stad',
            country: 'Land',
            proceed_payment: 'Doorgaan naar betaling',
            order_summary: 'Besteloverzicht',
            complete_order: 'Pre-order afronden, €{{amount}}',
            charge_note: 'Je kaart wordt nu afgeschreven voor €{{amount}}. Verwachte verzending: november/december 2026, pas zodra het product alle kwaliteitscontroles heeft doorstaan.',
            refund_note: 'Volledige terugbetaling mogelijk vóór verzending.',
            trust_points: ['Eenmalige betaling', 'Geen abonnement nodig', 'Verzending na kwaliteitscontrole', 'Refund mogelijk vóór verzending', 'Geen sucralose', 'Geen proprietary blends'],
            referral_label: 'Referral code',
            referral_optional: 'optioneel',
            referral_check: 'Controleer',
            referral_valid: 'Code geldig, je vriend(in) krijgt een gratis product zodra jouw bestelling is verzonden.',
            referral_invalid: 'Deze code wordt niet herkend.',
            referral_note: 'Een code gebruiken heeft geen invloed op jouw prijs. Degene die je de code heeft gegeven, verdient een gratis product, dit wordt 14 dagen na verzending van jouw bestelling bijgeschreven, om misbruik te voorkomen.',
            discount_label: 'Kortingscode',
            discount_optional: 'optioneel',
            discount_apply: 'Toepassen',
            discount_valid: 'Code toegepast: −€{{amount}} korting op je bestelling.',
            discount_invalid: 'Deze code is ongeldig of al gebruikt.',
            back: 'Terug',
        },
        login: {
            title: 'Inloggen bij Sleepstack',
            subtitle: 'Vul je e-mailadres in en we sturen je een magic link. Geen wachtwoord nodig.',
            email_placeholder: 'jouw@email.com',
            submit: 'Stuur inloglink',
            sending: 'Verzenden...',
            sent_title: 'Check je e-mail',
            sent_desc: 'We hebben een inloglink gestuurd naar',
            demo_note: 'E-mailservice niet geconfigureerd. Klik om in te loggen:',
            demo_btn: 'Klik om in te loggen (demo)',
            back_home: 'Terug naar home',
        },
        dashboard: {
            title: 'Mijn Account',
            welcome: 'Welkom terug',
            presale_notice: 'Je bevindt je in de voorverkoopfase. Abonnementsbeheer en leveringstracking worden geactiveerd na de productlancering (verwacht november/december 2026). Het referralprogramma is nu actief.',
            orders_title: 'Jouw Bestellingen',
            no_orders: 'Nog geen bestellingen.',
            order_id: 'Bestelling',
            order_date: 'Datum',
            order_status: 'Status',
            order_amount: 'Bedrag',
            profile_title: 'Profiel',
            name_label: 'Naam',
            email_label: 'E-mail',
            email_lang_label: 'E-mailtaal',
            email_lang_hint: 'We sturen al je e-mails (orderbevestiging, verzendupdates, referralcredits) in deze taal.',
            address_label: 'Opgeslagen verzendadres',
            address_hint: 'Vul dit één keer in, dan vullen we het automatisch in bij je volgende bestelling.',
            save: 'Wijzigingen opslaan',
            saved: 'Opgeslagen!',
            logout: 'Uitloggen',
            phase_label: 'Fase',
            phase_value: 'Voorverkoop',
            referral_title: 'Referrals',
            referral_heading: 'Jouw referralcode',
            referral_subhead: 'Deel deze code. Wanneer iemand hem gebruikt bij het afrekenen, verdien jij één gratis maand binnen je (toekomstige) abonnement, bijgeschreven op je account 14 dagen nadat die bestelling is verzonden.',
            referral_copy: 'Kopiëren',
            referral_copied: 'Gekopieerd!',
            referral_share: 'Delen',
            referral_stats_pending: 'In afwachting',
            referral_stats_available: 'Beschikbare credits',
            referral_stats_total: 'Succesvolle referrals',
            referral_redeem: 'Eén credit inwisselen',
            referral_redeem_note: 'Ingewisselde credits blijven bewaard tot je een abonnement start (na de lancering, verwacht november/december 2026). Elke credit dekt dan één maand van je lopende abonnement, wanneer jij dat wilt.',
            referral_policy_title: 'Zo werkt het',
            referral_policy_1: 'Elke succesvolle referral geeft je één gratis maand binnen je abonnement. Jij kiest wanneer je hem inzet, hij vervangt één maandelijkse factureringscyclus.',
            referral_policy_2: 'Credits worden pas bijgeschreven 14 dagen nadat de bestelling van je vriend(in) is verzonden. Zo beschermen we ons (en alle klanten) tegen misbruik van terugbetalingen.',
            referral_policy_3: 'Bestellingen met dubbele betaalgegevens of leveringsadressen kunnen worden gemarkeerd en niet bijgeschreven.',
            referral_empty: 'Nog geen referrals. Deel je code om je eerste gratis maand te verdienen.',
        },
        footer: {
            brandline: 'Voor jouw avond.',
            tagline: 'Bewijs eerst. Ontworpen in Nederland, geproduceerd in de EU.',
            product: 'Product',
            company: 'Bedrijf',
            legal: 'Juridisch',
            links_product: ['Pre-order', 'Ingrediënten', 'Wetenschap', 'FAQ'],
            links_company: ['Over ons', 'Blog', 'Contact'],
            links_legal: ['Privacybeleid', 'Algemene Voorwaarden'],
            disclaimer: 'Voedingssupplementen zijn niet bedoeld om ziekten te diagnosticeren, behandelen, genezen of voorkomen. Raadpleeg een zorgverlener voor gebruik.',
            rights: '© 2026 Sleepstack. Alle rechten voorbehouden.',
        },
        cookie: {
            title: 'Wij gebruiken cookies',
            desc: 'We gebruiken noodzakelijke cookies om de website te laten werken en optionele cookies om te zien hoe bezoekers de site gebruiken.',
            accept: 'Alles accepteren',
            reject: 'Alles weigeren',
            manage: 'Voorkeuren beheren',
            necessary: 'Noodzakelijk',
            analytics: 'Analyse',
            marketing: 'Marketing',
            save: 'Voorkeuren opslaan',
            always_on: 'Altijd aan',
        },
        privacy: {
            title: 'Privacybeleid',
        },
        terms: {
            title: 'Algemene Voorwaarden',
        }
    }
};
